import { __rest } from '../../../../_virtual/_tslib.js';
import React from 'react';
import { useAutocompleteContext } from '../../state/autocomplete-context.js';
import Button from '../../../../components/button/button.js';

function ListBoxActions(_a) {
  var {
      bem,
      children = 'Confirm',
      onClick,
      'aria-describedby': ariaDescribedByProp,
      selectedOptions,
      optionIdTemplate
    } = _a,
    rest = __rest(_a, ["bem", "children", "onClick", 'aria-describedby', "selectedOptions", "optionIdTemplate"]);
  const {
    dispatch,
    comboboxFieldRef
  } = useAutocompleteContext() || {};
  const selectedOptionsIds = selectedOptions ? selectedOptions.map(option => optionIdTemplate(option.value)) : [];
  const ariaDescribedBy = selectedOptionsIds || [];
  if (ariaDescribedByProp) ariaDescribedBy.push(ariaDescribedByProp.trim());
  return /*#__PURE__*/React.createElement("div", {
    className: bem.e('actions')
  }, /*#__PURE__*/React.createElement(Button, Object.assign({
    Elem: "button",
    onClick: event => {
      var _a;
      onClick === null || onClick === void 0 ? void 0 : onClick(event, selectedOptions);
      if (!event.preventHCREventHandling) {
        dispatch === null || dispatch === void 0 ? void 0 : dispatch({
          type: 'COLLAPSE',
          latestEvent: event
        });
        (_a = comboboxFieldRef === null || comboboxFieldRef === void 0 ? void 0 : comboboxFieldRef.current) === null || _a === void 0 ? void 0 : _a.focus();
      }
    },
    "aria-describedby": ariaDescribedBy.length ? ariaDescribedBy.join(' ') : undefined
  }, rest), children));
}

export { ListBoxActions };
